module.exports = __webpack_public_path__ + "img/2.6f9b8466.png";